import {Injectable} from "@angular/core";
import {CoreApiService} from "../service/core-api.service";
import {Observable} from "rxjs";
import {EndUserSignatureOverviewDto} from "../../cross/user-signatures/type/user-signatures.types";
import {ApiResponseDto, CustomerInfoPageInternalType} from "../interfaces/core.types";

@Injectable({ providedIn: 'root' })
export abstract class WelcomeApiService {

  endPoint: string = "mvseureg/eu/welcome"

  constructor(
    protected coreApiService: CoreApiService) {
  }

  public getWelcomePages(firstUse: boolean): Observable<EndUserSignatureOverviewDto> {
    return this.coreApiService.get(`${this.endPoint}/getWelcomePages`);
  }

  public getInfoPage(firstUse: boolean, internalType: CustomerInfoPageInternalType): Observable<EndUserSignatureOverviewDto> {
    return this.coreApiService.get(`${this.endPoint}/InfoPageInternal/${internalType}`);
  }

  public getTermsOfUse(): Observable<string> {
    return this.coreApiService.get(`${this.endPoint}/InfoPageInternal/termsOfUse`, { responseType: 'text' as 'json' });
  }
  public getAgb(): Observable<string> {
    return this.coreApiService.get(`${this.endPoint}/InfoPageInternal/agb`, { responseType: 'text' as 'json' });
  }

  public getPrivacyPolicy(): Observable<string> {
    return this.coreApiService.get(`${this.endPoint}/InfoPageInternal/dataProtection`, { responseType: 'text' as 'json' });
  }


}
